import preRequest from 'axios-pre-request/src/preRequest';

const pathName = location.pathname;

if (pathName.match(/\/knowledge\//)) {
    // 获取当前页面的数据表 nodeId
    let nodeId = '';
    try {
        const urlObj = new URL(window.location.href);
        const datasheetId = urlObj.searchParams.get('tb');
        if (datasheetId) {
            nodeId = datasheetId.split('_')[0];
        }
    } catch (e) {
        console.log(e);
    }

    const pathArr = pathName.replace(/\/knowledge\//, '').split('/');
    // const docIdBlackList = ['members', 'recycleBin', 'homeTag', 'intro'];
    // docIdBlackList中的单词都小于等于10，正常docid为14位
    if (pathArr.length === 4 && pathArr[3].length > 10) {
        const conf = {
            ttl: 10000, // default=60000,缓存的存在时间，单位ms
            useTime: 1, // default=null,消费次数，消费n次后缓存失效
            removeQuery: ['front_traceId', 'pre'],
            cb: (key, data, response) => {
                if (!(data instanceof Error)) {
                    if (data.returnCode !== 200) {
                        window.preRequestCache[key].state = 'failed';
                    }
                }
            }, // 此处可以进行业务状态码的控制、日志的上报等业务自定义动作
        };
        let host = location.origin;
        if (location.hostname === 'zhanglei.rl_doc_beta.dev.weiyun.baidu.com') {
            host = 'https://ku.dev.weiyun.baidu.com';
        }
        if (location.hostname === 'toc.dev.weiyun.baidu.com') {
            host = 'https://ku-external.dev.weiyun.baidu.com';
        }

        // 这部分代码执行的比较早，全局变量还没注入，需要通过域名进行请求path判断
        const tocWhiteList = [
            'toc.dev.weiyun.baidu.com',
            'ku-external.dev.weiyun.baidu.com',
            'ku-qa1-external.dev.weiyun.baidu.com',
            'ku-qa2-external.dev.weiyun.baidu.com',
            'ku-qa3-external.dev.weiyun.baidu.com',
            'ku-qa4-external.dev.weiyun.baidu.com',
            'kugray.baidu.com',
            'ku.baidu.com',
        ];
        const isTocPage = tocWhiteList.includes(location.hostname);
        const path = isTocPage ? '/wiki/ku/pass/index/info/query' : '/wiki/ku/index/info/query';

        preRequest({
            url: host + path +
                '?pre=1&front_traceId=' +
                new Date().getTime() +
                '_' +
                Math.floor(Math.random() * 10000),
            method: 'POST',
            credentials: 'include',
            params: {
                nodeId,
                docGuid: pathArr[3],
                groupGuid: pathArr[1],
                spaceGuid: pathArr[0],
                repositoryGuid: pathArr[2],
                type: 2,
            },
        }, conf);
    }
}


